import {Solutions} from '../core/model/solutions';
import {PortfolioSolutionsEnum} from '../core/model/portfolio-solutions.enum';
import {Portfolio} from '../portfolio/model/portfolio';

export const getPlatformSolutionFromPortfolioSolution = (portfolioSolution: PortfolioSolutionsEnum): Array<string> => {
  switch (portfolioSolution) {
    case PortfolioSolutionsEnum.DETTE:
      return [Solutions.insito, Solutions.apollo];
    case PortfolioSolutionsEnum.PROSPECTIVE:
      return [Solutions.inviseo];
    case PortfolioSolutionsEnum.DETTE_ET_PROSPECTIVE:
      return [Solutions.insito, Solutions.inviseo, Solutions.apollo];
    default:
      return [Solutions.insito];
  }
};

export const sortPortfoliosBySolution = (a: Portfolio, b: Portfolio): number => {
  if (a.solution === PortfolioSolutionsEnum.DETTE) {
    return -1;
  }

  if (b.solution === PortfolioSolutionsEnum.DETTE) {
    return 1;
  }

  // @ts-ignore
  if (a.solution === PortfolioSolutionsEnum.PROSPECTIVE && b.solution !== PortfolioSolutionsEnum.DETTE) {
    return -1;
  }

  // @ts-ignore
  if (a.solution !== PortfolioSolutionsEnum.DETTE && b.solution === PortfolioSolutionsEnum.PROSPECTIVE) {
    return 1;
  }

  return 0;
};
